var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUiFilledTrash124(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "#141414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.078 7l.672 12.758A2.384 2.384 0 008.128 22h7.744a2.384 2.384 0 002.378-2.245L18.922 7zm3.953 11H9a.5.5 0 01-.5-.469l-.5-8A.5.5 0 018.469 9 .478.478 0 019 9.469l.5 8a.5.5 0 01-.469.531zm3.469-.5a.5.5 0 01-1 0v-8a.5.5 0 011 0zm3 .031A.5.5 0 0115 18h-.031a.5.5 0 01-.468-.53l.5-8a.475.475 0 01.53-.47.5.5 0 01.468.53zM3.5 6h17a.5.5 0 000-1H15V3.5A1.5 1.5 0 0013.5 2h-3A1.5 1.5 0 009 3.5V5H3.5a.5.5 0 000 1zM10 3.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V5h-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiFilledTrash124);
export default __webpack_public_path__ + "static/media/ui-filled-trash-1-24.feb308cc.svg";
export { ForwardRef as ReactComponent };